import { render, staticRenderFns } from "./RewardReport.vue?vue&type=template&id=4b74d6a4&scoped=true"
import script from "./RewardReport.vue?vue&type=script&lang=js"
export * from "./RewardReport.vue?vue&type=script&lang=js"
import style0 from "./RewardReport.vue?vue&type=style&index=0&id=4b74d6a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b74d6a4",
  null
  
)

export default component.exports